/*
 * CommentHistory.tsx
 * Author: fwunderlich
 * Date: 13.02.2024
 *
 * Copyright: DMT GmbH & Co. KG
 */

import React, {useEffect} from 'react';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import Input from './Input';
import {classNames} from 'primereact/utils';

type Props = {
    comments: Comment[]
}

type Comment = {
    kommentar: string,
    zeitstempel: string,
    kommentar_type_id: number,
    type: string,
    ersteller: string,
    // type?: string,
    color: string
}

const CommentHistory = (props: Props) => {
    const {t} = useTranslation(['common', 'stammdaten']);

    const style = {
        comment: {
            backgroundColor: 'white',
            color: 'black',
            border: '1px solid black',
            borderRadius: '7px',
            padding: '10px'
        }
    };

    const colors = [
        '#e6e6fa5F',
        '#c6e2ff5F',
        '#b0e0e65F',
        '#d3ffce5F',
        '#edc3c35F',
        '#fad0b95F',
        '#f4f2c35F',];

    useEffect(() => {
        let temp: string[] = [];

        for (let i = 0; i < props.comments.length; i++) {
            let item = props.comments[i];

            if (temp.indexOf(item.ersteller) < 0) {
                temp.push(item.ersteller);
            }
            if (colors.length > temp.indexOf(item.ersteller)) {
                item.color = colors[temp.indexOf(item.ersteller)];
            }
        }
    }, []);

    return (<div className={'p-3'} style={{maxHeight: '200px', overflow: 'auto'}}>
        {props.comments.map((item: Comment, index: number) => {
            return <>
                <div className={classNames('p-2 flex', index > 0 ? 'mt-4' : '')}
                     style={{borderRadius: '7px', backgroundColor: item.color}}>
                    <div className={'font-bold mr-3'}>{item.type}</div>
                    <div>{moment(item.zeitstempel).format(t('datetimeformat')) + (` (${item.ersteller})`)}</div>
                </div>
                <div style={style.comment}><i>{item.kommentar}</i></div>
            </>;
        })}
    </div>);
};

export default CommentHistory;
